import { CandidateType, PartyType, RoundDataType, RoundType } from '../../../typings/parties-ranking';
import { IRowExtended } from '../../organisms';

import { IPartiesRanking, IPartiesRankingBlock } from './parties-ranking-block';

export const transform = (payload: IPartiesRanking): IPartiesRankingBlock => {
  const roundBlocks = payload?.rounds?.map((round: RoundType) => {
    let roundData: RoundDataType = [];

    if (round.candidates) {
      const candidatesData = round.candidates.flatMap((candidate: CandidateType) => {
        const candidateFullName = `${candidate.candidateName} ${candidate.candidateSurname}`;

        const candidateObj: IRowExtended = {
          isCandidate: true,
          isElected: candidate?.elected,
          name: candidateFullName,
          votes: candidate?.candidateVotes,
          percentage: candidate?.candidateVotesPercentage,
          seats: 0,
        };

        const candidatePartiesObj = candidate.parties
          ? candidate.parties.map((party: PartyType) => [
              {
                isCandidate: false,
                name: party.partyName,
                votes: party?.partyVotes,
                percentage: party?.partyVotesPercentage,
                seats: party?.partySeats || 0,
              },
            ])
          : [];

        return [[candidateObj], ...candidatePartiesObj];
      });

      roundData = [...roundData, ...candidatesData];
    }

    if (round.parties) {
      const partiesData = round.parties.map((party: PartyType) => [
        {
          isCandidate: false,
          name: party.partyName,
          votes: party?.partyVotes,
          percentage: party?.partyVotesPercentage,
          seats: party?.partySeats || 0,
        },
      ]);

      roundData = [...roundData, ...partiesData];
    }

    return {
      roundName: round.round,
      roundData,
    };
  });

  const isEuropean = payload.type === 'europee';
  const {
    lastUpdate: isoTimestamp,
    type: electionType,
    entity,
    percentageTurnout,
    partialPollingStations,
    totalPollingStations,
  } = payload;
  const { name: entityName } = entity;

  return {
    isoTimestamp,
    roundBlocks,
    entityName,
    electionType,
    isEuropean,
    turnoutData: {
      percentageTurnout,
      partialPollingStations,
      totalPollingStations,
    },
  };
};
